import { forwardRef } from 'react';

// using the builtin forwardRef types makes the component lose the generics
export const typePreservingForwardRef: <T>(c: T) => T = forwardRef as any;
